module.exports = __webpack_public_path__ + "img/reddit.bba85f5c.png";